import { UseQueryResult, skipToken, useQuery } from "@tanstack/react-query";
import { Company } from "api/schema/companies/companySchema";
import { AxiosError } from "axios";
import { usePublicApiService } from "contexts/PublicApiServiceProvider";

export const companyKeys = {
  any: ["getCompany"],
  one: (companyId?: string) => [...companyKeys.any, { companyId }],
};

export const useGetCompany = ({
  companyId,
}: {
  companyId?: string;
}): UseQueryResult<Company, AxiosError> => {
  const publicApi = usePublicApiService();
  return useQuery<Company, AxiosError>({
    staleTime: 60 * 60_000,
    queryKey: companyKeys.one(companyId),
    queryFn: companyId ? () => publicApi.getCompany({ companyId }) : skipToken,
  });
};
